// extracted by mini-css-extract-plugin
module.exports = {"productPlaceholder":"productPlaceholder___bzyh7","spinnerMain":"spinnerMain___2mnNA","spinner":"spinner___B_heH","load8":"load8___3PN8C"};